/**
 * What the app needs to describe and configure Grove's MCP server.
 *
 * These snippets are what a user pastes into their agent's config, so they
 * have to match `packages/mcp-server` exactly — package name, env var,
 * transport, tool list. Change one, change both.
 */

export const MCP_PACKAGE = '@grove/mcp-server';

export const MCP_DOCS_URL = 'https://grovereader.com/docs/mcp';

/** Mirrors TOOLS in packages/mcp-server/src/index.ts. */
export const MCP_TOOLS = [
  { name: 'grove_add_article', description: 'Clip a URL into your queue' },
  { name: 'grove_list_queue', description: 'List articles by status' },
  { name: 'grove_get_article', description: 'Read content, highlights, and notes' },
  { name: 'grove_update_article', description: 'Change status, tags, notes, or vault path' },
  { name: 'grove_search_library', description: "Search everything you've saved" },
  { name: 'grove_add_highlight', description: 'Keep a passage, with an optional note' },
  { name: 'grove_recent_highlights', description: "Catch up on what you've highlighted" },
] as const;

/** Where each host keeps the JSON config below. */
export const MCP_HOST_PATHS = [
  { host: 'Claude Desktop', path: '~/.claude/claude_desktop_config.json' },
  { host: 'Cursor', path: '~/.cursor/mcp.json' },
] as const;

export function mcpConfigJson(token: string): string {
  return JSON.stringify(
    {
      mcpServers: {
        grove: {
          command: 'npx',
          args: [MCP_PACKAGE],
          env: { GROVE_TOKEN: token },
        },
      },
    },
    null,
    2,
  );
}

export function claudeCodeCommand(token: string): string {
  return `claude mcp add grove -e GROVE_TOKEN=${token} -- npx ${MCP_PACKAGE}`;
}
